import { Paper, Skeleton, Stack, Typography } from "@mui/material";
import { formatCompactNumber } from "../../../../../../common/utils";

export interface CardDeltaValue {
	title: string;
	value: string;
	measure: string;
	maximumFractionDigits?: number;
}

export interface CardDeltaProps {
	title?: string;
	value?: string;
	measure?: string;
	values?: CardDeltaValue[];
	isLoading?: boolean;
}

export const CardDelta = ({ title, value, measure, values, isLoading }: CardDeltaProps) => {
	if (isLoading) {
		return <Skeleton variant="rounded" height={100} width={160} />;
	}

	const hasMultipleValues = values && values.length > 0;

	return (
		<Paper elevation={0} sx={{ p: 2, minWidth: 120 }}>
			<Stack gap={2}>
				{title && (
					<Typography variant="subtitle2" fontWeight={500}>
						{title}
					</Typography>
				)}

				{hasMultipleValues ? (
					<Stack direction="row" spacing={4}>
						{values.map((item, index) => (
							<Stack key={`${item.title}-${index}`} gap={2} minWidth="fit-content">
								<Typography variant="subtitle2" fontWeight={500} color="text.secondary">
									{item.title}
								</Typography>

								<Stack direction="row" spacing={1} alignItems="end">
									<Typography variant="h4" fontWeight={400}>
										{formatCompactNumber(
											Number(item.value),
											0,
											item.maximumFractionDigits ? item.maximumFractionDigits : 1
										)}
									</Typography>

									<Typography variant="caption" color="text.secondary" pb={0.2}>
										{item.measure}
									</Typography>
								</Stack>
							</Stack>
						))}
					</Stack>
				) : (
					<Stack direction="row" spacing={1} alignItems="end">
						<Typography variant="h4" fontWeight={400}>
							{formatCompactNumber(Number(value), 0, 1)}
						</Typography>

						<Typography variant="caption" color="text.secondary" pb={0.2}>
							{measure}
						</Typography>
					</Stack>
				)}
			</Stack>
		</Paper>
	);
};
